module.exports = __webpack_public_path__ + "static/media/it.6828c8de.svg";